import React from 'react';

import { type Variants } from 'framer-motion';
import { useTheme } from 'styled-components';

import { YatLogo } from '@pkg/assets/brand';

import { NftCardPlaceholderAsset, NftCardPlaceholderText, NftCardPlaceholderWrapper } from './styles';

export interface NftPlaceholderCardProps {
    // TODO: What is this `custom` prop? It does not appear to
    // actually pass-through to <NftCardPlaceholderWrapper />.
    custom: number;
}

export function NftPlaceholderCard({ custom }: NftPlaceholderCardProps) {
    const theme = useTheme();

    const variants: Variants = {
        show: (index) => ({
            opacity: 1,
            transition: {
                delay: index * 0.05,
                duration: theme.transitions.speeds.slow,
                staggerChildren: 0.5,
                repeat: Infinity,
                repeatType: 'reverse',
            },
        }),
        exit: { opacity: 0.2 },
        hidden: { opacity: 0.3 },
    };

    const variantLoop: Variants = {
        hidden: { opacity: 0.3 },
        show: {
            opacity: 1,
            transition: { duration: theme.transitions.speeds.fast },
        },
    };

    return (
        <NftCardPlaceholderWrapper
            custom={custom}
            initial="hidden"
            animate="show"
            variants={variants}
            aria-live="polite"
            aria-busy="true"
        >
            <NftCardPlaceholderAsset variants={variantLoop} initial="hidden" animate="show">
                <YatLogo opacity={0.1} width="41px" height="46px" />
            </NftCardPlaceholderAsset>

            <NftCardPlaceholderText variants={variantLoop} initial="hidden" animate="show" $height={18} />

            <NftCardPlaceholderText variants={variantLoop} initial="hidden" animate="show" $height={14} />

            <NftCardPlaceholderText variants={variantLoop} initial="hidden" animate="show" $height={14} />
        </NftCardPlaceholderWrapper>
    );
}
